import { TFunction } from 'i18next';
import { createColumnHelper } from '@tanstack/react-table';
import {
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import { Icons } from '@texas/components/shared/Icons';
import { ArchivedTooltip } from '@texas/components/shared/tooltip/ArchivedTooltip';
import { TemplateRangeTier } from '@texas/api/endpoints/metadata/templateRangeTiersApi';

export const vdcTierTableColumns = (
  t: TFunction,
  onArchiveOpen: (tier: TemplateRangeTier) => void,
  onRestore: (id: number) => Promise<void>,
  onEditOpen: (id: number) => void,
) => {
  const columnHelper = createColumnHelper<TemplateRangeTier>();
  const columns = [
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: t('general.name'),
      enableSorting: false,
      maxSize: 200,
    }),
    columnHelper.accessor('startRange', {
      cell: (info) => info.getValue(),
      header: t('configuration.startRange'),
      enableSorting: false,
      maxSize: 150,
    }),
    columnHelper.accessor('endRange', {
      cell: (info) => info.getValue(),
      header: t('configuration.endRange'),
      enableSorting: false,
      maxSize: 150,
    }),
    columnHelper.accessor('costMultiplier', {
      cell: (info) => info.getValue(),
      header: t('configuration.costMultiplier'),
      enableSorting: false,
      maxSize: 150,
    }),
    columnHelper.accessor('id', {
      cell: (info) => (
        <>
          <Flex justifyContent="end" alignItems="center" gap={4}>
            {info.row.original.archived && (
              <ArchivedTooltip archived={info.row.original.archived} />
            )}
            <Menu placement="left" variant="entityDirectory">
              <MenuButton float="right" aria-label={t('general.more')}>
                <Icons.DotsHorizontal boxSize={6} />
              </MenuButton>
              <Portal>
                <MenuList zIndex={99}>
                  <MenuItem
                    icon={<Icons.Pencil boxSize={5} />}
                    onClick={() => onEditOpen(info.row.original.id)}
                  >
                    {t('general.edit')}
                  </MenuItem>
                  {info.row.original.archived ? (
                    <MenuItem
                      color="entityDirectory.primaryBackground"
                      icon={<Icons.Undo boxSize={5} />}
                      onClick={() => onRestore(info.row.original.id)}
                    >
                      {t('general.restore')}
                    </MenuItem>
                  ) : (
                    <MenuItem
                      color="entityDirectory.dangerText"
                      icon={<Icons.Archive boxSize={5} />}
                      onClick={() => onArchiveOpen(info.row.original)}
                    >
                      {t('general.archive')}
                    </MenuItem>
                  )}
                </MenuList>
              </Portal>
            </Menu>
          </Flex>
        </>
      ),
      header: '',
      enableSorting: false,
      maxSize: 100,
    }),
  ];

  return columns;
};
